module.exports = __webpack_public_path__ + "img/Flat-Mountains.ddf7fec2.svg";